let n = 0
export const rewards = [
  {
    id: n++,
    name: '瑞鶴',
    icon: null,
    ema: 8000,
    max: 1
  },
  {
    id: n++,
    name: '九三式酸素魚雷',
    icon: null,
    ema: 6000,
    max: 1
  },
  {
    id: n++,
    name: '410mm連装砲(三式弾)T0',
    icon: null,
    ema: 2500,
    max: 1
  },
  {
    id: n++,
    name: '烈風',
    icon: null,
    ema: 2500,
    max: 1
  },
  {
    id: n++,
    name: 'フロアライト',
    icon: null,
    ema: 1200,
    max: 1
  },
  {
    id: n++,
    name: 'あずまや',
    icon: null,
    ema: 1200,
    max: 1
  },
  {
    id: n++,
    name: 'コイのぼり',
    icon: null,
    ema: 1200,
    max: 1
  },
  {
    id: n++,
    name: '魚の絵',
    icon: null,
    ema: 300,
    max: 1
  },
  {
    id: n++,
    name: '蔵王重工装備箱T4',
    icon: null,
    ema: 300,
    max: 10
  },
  {
    id: n++,
    name: 'パンプキン',
    icon: null,
    ema: 50,
    max: 10
  },
  {
    id: n++,
    name: '酸素コーラ',
    icon: null,
    ema: 15,
    max: 100
  }
]



// WEBPACK FOOTER //
// ./src/rewards.js